import { render, staticRenderFns } from "./HowToScreen.vue?vue&type=template&id=05d3d10f&"
import script from "./HowToScreen.vue?vue&type=script&lang=js&"
export * from "./HowToScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports